export const CURRENCIES = {
  INR: { symbol: '₹', name: 'Indian Rupee', code: 'INR' },
  USD: { symbol: '$', name: 'US Dollar', code: 'USD' },
  EUR: { symbol: '€', name: 'Euro', code: 'EUR' }
};

// Format number with Indian comma separators (1,00,000 style)
const formatIndianNumber = (num) => {
  const numStr = Math.floor(num).toString();
  if (numStr.length <= 3) return numStr;
  
  let result = '';
  const lastThree = numStr.slice(-3);
  const remaining = numStr.slice(0, -3);
  
  if (remaining.length > 0) {
    // Add commas every 2 digits for the remaining part
    const reversed = remaining.split('').reverse().join('');
    const chunks = reversed.match(/.{1,2}/g);
    result = chunks.join(',').split('').reverse().join('') + ',' + lastThree;
  } else {
    result = lastThree;
  }
  
  return result;
};

// Format number with Western comma separators (1,000,000 style)
const formatWesternNumber = (num) => {
  return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Convert to human-readable format (Lakhs/Crores for INR, K/M/B for others)
export const formatHumanReadable = (amount, currencyCode = 'INR') => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '';
  
  if (currencyCode === 'INR') {
    if (num >= 10000000) { // 1 Crore+
      return `${(num / 10000000).toFixed(2)} Cr`;
    } else if (num >= 100000) { // 1 Lakh+
      return `${(num / 100000).toFixed(2)} L`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(2)} K`;
    }
    return num.toFixed(0);
  } else {
    if (num >= 1000000000) {
      return `${(num / 1000000000).toFixed(2)}B`;
    } else if (num >= 1000000) {
      return `${(num / 1000000).toFixed(2)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(2)}K`;
    }
    return num.toFixed(0);
  }
};

export const formatCurrency = (amount, currencyCode = 'INR') => {
  const currency = CURRENCIES[currencyCode] || CURRENCIES.INR;
  const num = parseFloat(amount);
  
  if (isNaN(num)) return `${currency.symbol}0`;
  
  // Use Indian formatting for INR, Western for others
  const formattedNumber = currencyCode === 'INR' 
    ? formatIndianNumber(num) 
    : formatWesternNumber(num);
  
  // Add decimals for smaller amounts, skip for large amounts
  const decimals = num < 100000 ? `.${(num % 1).toFixed(2).slice(2)}` : '';
  
  return `${currency.symbol}${formattedNumber}${num < 100000 ? decimals : ''}`;
};

// Format with both exact amount and human-readable label
export const formatCurrencyWithLabel = (amount, currencyCode = 'INR') => {
  const formatted = formatCurrency(amount, currencyCode);
  const humanReadable = formatHumanReadable(amount, currencyCode);
  return { formatted, humanReadable };
};

export const getCurrencySymbol = (currencyCode = 'INR') => {
  const currency = CURRENCIES[currencyCode] || CURRENCIES.INR;
  return currency.symbol;
};

